import moment from "moment"
import React, { useEffect, useState } from "react"
import { Badge, Button, Tab, Tabs, Toast, ToastContainer } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import ScaleLoader from "react-spinners/ScaleLoader"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import ConfirmModal from "../../components/Common/ConfirmModal"
import { SERVICE_TYPE } from "../../constants/constants"
import { RootState } from "../../store"
import {
    clearError,
    // updateValueAddedService
    createValueAddedService,
    deleteValueAddedService,
    loadValueAddedServices,
    resetSuccess,
    setTab,
    updateValueAddedService
} from "../../store/pricing.store"
import Header from "../Layout/Header"
import ValueAddedServiceModal from "./ValueAddedServiceModal"
// import DateRangePickerCustom from "components/Common/DateRangePicker/DateRangePickerCustom";
import ValueAddedServiceTable from "./ValueAddedServicesTable"

const ValueAddedServices = () => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()
    const { userInfo, defaultWarehouse } = useAppSelector((state: RootState) => state.auth)
    const { valueAddedServices, loading, error, success, tab } = useAppSelector(
        (state: RootState) => state.pricing
    )
    const { selectedWarehouse } = useAppSelector((state: RootState) => state.warehouses)

    const [valueAddedServicesDetails, setValueAddedServiceDetails] = useState({} as Record<string, any>)
    const [show, setShow] = useState("")

    const [errors, setErrors] = useState({} as Record<string, any>)
    useEffect(() => {
        if (selectedWarehouse || defaultWarehouse)
            dispatch(
                loadValueAddedServices({
                    warehouse: selectedWarehouse?.toString() || defaultWarehouse?.toString()
                })
            )
    }, [])

    const handleSubmit = async (valueAddedServicesDetails: Record<string, any>) => {
        if (valueAddedServicesDetails?.id) {
            await dispatch(
                updateValueAddedService({
                    existingValueAddedServiceData: valueAddedServicesDetails,
                    warehouse: (selectedWarehouse || defaultWarehouse).toString()
                })
            )
        } else {
            await dispatch(
                createValueAddedService({
                    newValueAddedServiceData: {
                        ...valueAddedServicesDetails,
                        warehouse_id: selectedWarehouse,
                        is_external: tab === "internal" ? 0 : 1,
                        category: "parcel-ops",
                        service_type: valueAddedServicesDetails?.service_type
                            ? valueAddedServicesDetails?.service_type
                            : SERVICE_TYPE["1"]
                    }
                })
            )
        }
    }

    useEffect(() => {
        if (success) {
            setValueAddedServiceDetails({})
            dispatch(
                loadValueAddedServices({
                    warehouse: selectedWarehouse?.toString() || defaultWarehouse?.toString()
                })
            )
            setShow("")
            dispatch(resetSuccess())
        }
    }, [success])

    return (
        <>
            {(!error && loading) || !userInfo?.accessToken ? (
                <div className="loader row justify-content-center">
                    <ScaleLoader color="#15397F" width={4} height={40} />
                </div>
            ) : (
                <div className="valueAddedServices-container">
                    {error?.message && (
                        <ToastContainer className="p-3" position={"top-end"}>
                            <Toast onClose={() => dispatch(clearError())}>
                                <Toast.Header closeButton>
                                    <strong className="me-auto text-danger">VAS delete Error</strong>
                                    <small>{moment(error?.createdAt?.valueOf()).fromNow()}</small>
                                </Toast.Header>
                                <Toast.Body className="text-danger">{error?.message}</Toast.Body>
                            </Toast>
                        </ToastContainer>
                    )}
                    <Header
                        title={t("Pricing / Value Added Service")}
                        records={valueAddedServices?.length}
                        data={valueAddedServices}
                        name="ValueAddedService"
                        //buttonId="#valueAddedServicesExportButton"
                    >
                        <div className="mx-2">
                            {/*<DateRangePickerCustom setStartDate={setStartDate} setEndDate={setEndDate} />*/}
                        </div>
                    </Header>
                    <div className="row justify-content-end px-5 mt-3">
                        <Button
                            className="col-2"
                            onClick={() => {
                                setValueAddedServiceDetails({})
                                setErrors({})
                                setShow("editOrCreateModal")
                            }}>
                            {t("Add VAS")}
                        </Button>
                    </div>
                    <div className="row  d-flex tabs-data px-2">
                        <Tabs
                            id="vas-tab"
                            className="mt-4"
                            activeKey={tab}
                            onSelect={(k: any) => {
                                dispatch(setTab(k as string))
                            }}>
                            <Tab
                                eventKey="internal"
                                title={
                                    <>
                                        {t("Internal")}
                                        <Badge className="mx-2 px-2">
                                            {
                                                valueAddedServices?.filter(
                                                    (vas: Record<string, any>) => !vas?.is_external
                                                )?.length
                                            }
                                        </Badge>
                                    </>
                                }>
                                <ValueAddedServiceTable
                                    valueAddedServices={valueAddedServices?.filter(
                                        (vas: Record<string, any>) => !vas?.is_external
                                    )}
                                    valueAddedServiceDetails={valueAddedServicesDetails}
                                    setValueAddedServiceDetails={setValueAddedServiceDetails}
                                    setErrors={setErrors}
                                    setShow={setShow}
                                />
                            </Tab>
                            <Tab
                                eventKey="external"
                                title={
                                    <>
                                        {t("External")}
                                        <Badge className="mx-2 px-2">
                                            {
                                                valueAddedServices?.filter(
                                                    (vas: Record<string, any>) => vas?.is_external
                                                )?.length
                                            }
                                        </Badge>
                                    </>
                                }>
                                <ValueAddedServiceTable
                                    valueAddedServices={valueAddedServices?.filter(
                                        (vas: Record<string, any>) => vas?.is_external
                                    )}
                                    valueAddedServiceDetails={valueAddedServicesDetails}
                                    setValueAddedServiceDetails={setValueAddedServiceDetails}
                                    setShow={setShow}
                                    setErrors={setErrors}
                                />
                            </Tab>
                        </Tabs>
                    </div>
                    <ValueAddedServiceModal
                        loading={loading}
                        show={show}
                        setShow={setShow}
                        valueAddedServiceDetails={valueAddedServicesDetails}
                        setValueAddedServiceDetails={setValueAddedServiceDetails}
                        handleClose={() => setShow("")}
                        handleSubmit={handleSubmit}
                        errors={errors}
                        setErrors={setErrors}
                    />
                    <ConfirmModal
                        show={show}
                        data={valueAddedServicesDetails?.id || {}}
                        handleClose={() => {
                            setValueAddedServiceDetails({})
                            setShow("")
                        }}
                        handleSubmit={(id: number) => {
                            dispatch(deleteValueAddedService(id))
                            setShow("")
                        }}
                        title={"Delete Value Added Service"}
                    />
                </div>
            )}
        </>
    )
}

export default ValueAddedServices
